import {Component} from '@angular/core';
import {BackendService} from "@app/core/backendService/backend.service";
import {CredentialsService} from "@app/core/authentication/credentials.service";
import {PointService} from "./../service/point/point.service";
import {Point} from "@core/models/Point";
import {orderBy as _orderBy} from 'lodash'
import {map, startWith} from "rxjs/operators";
import {ActivatedRoute, Params} from "@angular/router";
import {Category, Purchase, Reward} from "@app/feature/reward/models/Reward";
import {RewardService} from "@app/feature/reward/service/reward.service";
import {Observable} from "rxjs";
import {PaginableList} from "@shared/helpers/PaginableList";


@Component({
  selector: 'app-user-reward',
  templateUrl: './user-reward.component.html',
  styleUrls: ['./user-reward.component.scss'],
})
export class UserRewardComponent{
  constructor(
    public rewardService: RewardService,
    public backendService: BackendService,
    public pointService: PointService,
    public credentialsService: CredentialsService,
    private route: ActivatedRoute
  ) {
    this.point$ = pointService.points$
    this.categories$ = rewardService.rewardCategory$

    this.reward$ = rewardService.reward$.pipe(map((reward: Reward[])=>new PaginableList<Reward>(reward)))

    this.purchase$ = rewardService.purchase$.pipe(map((purchases: Purchase[])=>
      new PaginableList<Purchase>(_orderBy<Purchase>(purchases, ['created'], ['desc']))
    ))

    this.viewMode$ = this.route.params.pipe(
      map<Params, 'available'|'obtained'>((params:Params)=>params?.mode==='obtained' ? 'obtained' : 'available'),
      startWith('available')
    )
  }

  public reward$: Observable<PaginableList<Reward>>
  public categories$: Observable<Category[]>
  public purchase$: Observable<PaginableList<Purchase>>
  public point$: Observable<Point>
  public viewMode$: Observable<'available'|'obtained'>
}
